<template>
    <div class="pro-page auto">
      <div class="imgbox auto" @click="playVideo('https://qiniu.eub-inc.com/video/20231106/HDX.mp4')"><img :src="url + '/activity/hdx/img1.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img2.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img3.jpg'" alt=""></div>

      <div class="imgbox swiper-container1 auto">
        <div class="swiper-wrapper">
          <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/img4.jpg'" alt=""></div>
          <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/1.png'" alt=""></div>
          <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/2.png'" alt=""></div>
          <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/3.png'" alt=""></div>
        </div>
      </div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img5.jpg'" alt=""></div>

      <div class="imgbox swiper-container1 auto">
        <div class="swiper-wrapper">
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/img6.jpg'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/7.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/8.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/9.png'" alt=""></div>
        </div>
      </div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img7.jpg'" alt=""></div>

      <div class="imgbox swiper-container1 auto">
        <div class="swiper-wrapper">
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/img8.jpg'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/9.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/10.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/11.png'" alt=""></div>
        </div>
      </div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img9.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img10.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img11.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img12.jpg'" alt=""></div>

      <div class="imgbox swiper-container1 auto">
        <div class="swiper-wrapper">
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/img13.jpg'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/12.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/13.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/14.png'" alt=""></div>
        </div>
      </div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img14.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img15.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img16.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img17.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img18.jpg'" alt=""></div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img19.jpg'" alt=""></div>

      <div class="imgbox swiper-container1 auto">
        <div class="swiper-wrapper">
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/img20.jpg'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/15.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/16.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/17.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/18.png'" alt=""></div>
            <div class="swiper-slide"><img v-lazy="url + '/activity/hdx/19.png'" alt=""></div>
        </div>
      </div>

      <div class="imgbox auto"><img v-lazy="url + '/activity/hdx/img21.jpg'" alt=""></div>
  
      <div class="video-popup auto" v-if="showVideo">
  
        <div class="close auto" @click="closeVideo"><img src="@/assets//close.png" alt=""></div>
        <div class="videobox auto">
          <video :src="videoSrc" webkit-playsinline="true" playsinline="true" x5-video-player-type="h5-page" autoplay controls style="width: 100vw;height: 56.24vw;"></video>
        </div>
  
      </div>
  
    </div>
  </template>
  
  <script>
  import Swiper from 'swiper';
  export default {
    data () {
      return {
        container1index: 0,
        videoSrc: '',
        showVideo: false,
        url: 'https://elantran-cnd.vintro.cn/elantra_n_client_activity/images'
      }
    },
    methods: {
      playVideo (src) {
        this.showVideo = true
        this.videoSrc = src
      },
      closeVideo () {
        this.showVideo = false
      }
    },
    mounted(){

      this.$wx.miniProgram.getEnv((res)=>{
        if (res.miniprogram) {
          // alert("在小程序里");
          this.$wx.miniProgram.postMessage({
            data: {
              title: '现代汽车全球驾驶培训燃擎落幕'
            }
          })
        }
      })
  
      var _that = this
  
      var swiper1 = new Swiper ('.swiper-container1', {
        loop: false,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        on:{
          transitionEnd: function(){
            _that.container1index = swiper1.activeIndex
            console.log(swiper1.activeIndex)
          }
        }
      })
  
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .pro-page {
    background: #000;
  }
  
  .video-popup {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #000;
    z-index: 99;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .close {
      width: 5.4vw;
      position: absolute;
      right: 8vw;
      top: 15vw;
    }
  }
  
  .swiper-container1 {
    position: relative;
    .swiper-pagination {
      position: absolute;
      left: 0;
      bottom: 5vw;
      z-index: 9;
      width: 100%;
      text-align: center;
      ul {
        li {
          display: inline-block;
          width: 2.2vw;
          height: 2.2vw;
          overflow: hidden;
          border-radius: 2.2vw;
          background: #fff;
          margin: 0 1.2vw;
        }
        li.cur {
          background: #e63312;
        }
      }
    }
    .swiper-button-prev {
      position: absolute;
      left: 2vw;
      top: 34%;
      z-index: 9;
      img {
        width: 3vw;
      }
    }
    .swiper-button-next {
      position: absolute;
      right: 2vw;
      top: 34%;
      z-index: 9;
      img {
        width: 3vw;
      }
    }
  }
  .swiper-container-card {
    background: #bed6f2;
    height: 64vw;
    margin-bottom: 17.6vw;
    .swiper-wrapper {
      align-items: center;
    }
    .swiper-slide-prev {
      img {
        height: 40vw;
        width: auto;
        position: absolute;
        left: -39vw;
        top: 5vw;
      }
    }
    .swiper-slide-active {
      z-index: 9;
      img {
        height: 47.33vw;
        width: auto;
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
      }
    }
    .swiper-slide-next {
      img {
        height: 40vw;
        width: auto;
        position: absolute;
        right: -39vw;
        top: 5vw;
      }
    }
  }
  </style>